// Phase 15 — Pro Team + Analytics API client.
import { apiFetch } from './api';

// 15a: Analytics
export const getProAnalytics = () => apiFetch('/api/v1/pro/analytics');

// 15b: Team roster
export const getTeam = () => apiFetch('/api/v1/pro/team');

export const inviteTeamMember = (email) =>
  apiFetch('/api/v1/pro/team/invite', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });

export const cancelTeamInvite = (inviteId) =>
  apiFetch(`/api/v1/pro/team/invites/${encodeURIComponent(inviteId)}/cancel`, { method: 'POST' });

export const listPendingTeamInvites = () =>
  apiFetch('/api/v1/pro/team/invites/pending');

export const acceptTeamInvite = (inviteId, token) =>
  apiFetch(`/api/v1/pro/team/invites/${encodeURIComponent(inviteId)}/accept`, {
    method: 'POST',
    body: JSON.stringify({ token: token || undefined }),
  });

export const declineTeamInvite = (inviteId, token) =>
  apiFetch(`/api/v1/pro/team/invites/${encodeURIComponent(inviteId)}/decline`, {
    method: 'POST',
    body: JSON.stringify({ token: token || undefined }),
  });

export const removeTeamMember = (memberUserId) =>
  apiFetch(`/api/v1/pro/team/members/${encodeURIComponent(memberUserId)}`, { method: 'DELETE' });

export const setAutoAddNewEvents = (memberUserId, enabled) =>
  apiFetch(`/api/v1/pro/team/members/${encodeURIComponent(memberUserId)}/auto-add`, {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });

// Per-event team access
export const getEventTeamAccess = (eventId) =>
  apiFetch(`/api/v1/events/${encodeURIComponent(eventId)}/team-access`);

export const setEventTeamAccess = (eventId, memberUserId, enabled) =>
  apiFetch(`/api/v1/events/${encodeURIComponent(eventId)}/team-access/${encodeURIComponent(memberUserId)}`, {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });
